import React, { memo, useMemo } from 'react';
import { Avatar, Card, CardContent, Link } from '@mui/material';
import { useIntl } from 'react-intl';
import TeamMemberLink from '../../common/TeamMemberLink';
import { stringAvatar } from '../../../utils/common.util';
import TeamLink from '../../common/TeamLink';
import EventLink from '../../common/EventLink';
import messages from '../../common/messages';
import { WrappedTypography } from '../../common/ui/Typography';
import { ZeroMinWidthCardHeader } from '../../common/ui/Container';

function DuplicateMember({ member }) {
  const intl = useIntl();
  const translatedMessages = useMemo(
    () => ({
      teamTxt: intl.formatMessage(messages.team),
      eventTxt: intl.formatMessage(messages.event),
    }),
    [intl],
  );
  const { displayName, avatarUrl, team, id, phone } = member;
  const eventId = team?.event?.id;
  const teamName = team?.name;
  const teamId = team?.id;
  const eventName = team?.event?.name;
  const eventGroupId = team?.event?.eventGroupId;
  const memberAvatar = stringAvatar(displayName);
  return (
    <Card sx={{ height: '100%' }}>
      <ZeroMinWidthCardHeader
        avatar={
          <Avatar sx={memberAvatar.sx} src={avatarUrl}>
            {memberAvatar.children}
          </Avatar>
        }
        title={
          <TeamMemberLink
            displayName={displayName}
            id={id}
            eventId={eventId}
            eventGroupId={eventGroupId}
          ></TeamMemberLink>
        }
        subheader={
          phone ? (
            <Link
              sx={{ minWidth: 0, whiteSpace: 'normal' }}
              href={`tel:${phone}`}
            >
              {phone}
            </Link>
          ) : null
        }
      />
      <CardContent sx={{ pt: 0 }}>
        <WrappedTypography component="div">
          {`${translatedMessages.teamTxt} : `}
          <TeamLink
            id={teamId}
            eventId={eventId}
            eventGroupId={eventGroupId}
            displayName={teamName}
          />
        </WrappedTypography>
        <WrappedTypography component="div">
          {`${translatedMessages.eventTxt} : `}
          <EventLink
            id={eventId}
            eventGroupId={eventGroupId}
            displayName={eventName}
          />
        </WrappedTypography>
      </CardContent>
    </Card>
  );
}

export default memo(DuplicateMember);
